
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"44","height":"44","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30.624 35.024a1.91 1.91 0 01-1.408 1.408L3.168 43.12c-.704.176-1.408 0-1.76-.528-.352-.352-.704-1.056-.528-1.76l6.688-26.048a1.91 1.91 0 011.408-1.408c.704-.176 1.408 0 1.936.528 2.288 2.288 6.16 2.64 8.8.704l2.992-2.992-1.056-1.056c-.352-.352-.528-.88-.528-1.408 0-.528.176-1.056.528-1.408l6.336-6.336c.88-.704 1.936-.704 2.816 0L42.592 13.2c.352.352.528.88.528 1.408 0 .528-.176 1.056-.528 1.408l-6.512 6.512c-.352.352-.88.528-1.408.528-.528 0-.88-.176-1.232-.704l-1.056-1.056-2.992 2.992c-1.936 2.64-1.584 6.512.704 8.8.528.528.704 1.232.528 1.936zM25.52 23.232l-4.928-4.928c-3.168 1.584-7.04 1.584-10.032 0L6.336 34.848l2.992-2.992c-.352-1.232 0-2.816 1.056-3.872 1.584-1.584 4.048-1.584 5.456 0 1.584 1.584 1.584 4.048 0 5.456-1.056 1.056-2.464 1.408-3.872 1.056l-2.992 2.992L25.52 33.44c-1.584-3.168-1.584-7.04 0-10.208z","fill":"#4D6788","opacity":".2"}})])
          )
        }
      }
    